import Vue from 'vue';
import AcaciaPlugin from '@produtos/vue-acacia-plugin';
import VuetifyColors from 'vuetify/es5/util/colors';

import 'vuetify/dist/vuetify.css';
import Cookies from 'js-cookie';

import App from './App';
import store from './store';
import router from './router';
import Redirect from './services/redirect';

Vue.use(AcaciaPlugin, {
  theme: {
    primary: '#01182b',
    secondary: VuetifyColors.blue.darken2,
    accent: VuetifyColors.amber.base,
    error: VuetifyColors.red.base,
    warning: VuetifyColors.orange.base,
    info: VuetifyColors.lightBlue.base,
    success: VuetifyColors.green.base,
  },
});

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  render: h => h(App),
  created() {
    Cookies.remove(
      'AcaciaToken',
      { domain: window.location.hostname },
    );
    this.$store.dispatch('Acacia/Start', ['auth', 'pin'])
      .then((user) => {
        if (user) Redirect(this.$store, this.$route);
      })
      .catch();
  },
});



// WEBPACK FOOTER //
// ./src/main.js